import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "./Login.css";

const Login = ({ onLoginSuccess }) => {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [gu, setGu] = useState("1");

  useEffect(() => {
    const savedId = Cookies.get("id");
    const savedGu = Cookies.get("gu");

    if (savedId && savedGu) {
      setId(savedId);
      setGu(savedGu);
      setRememberMe(true);
    }
  }, []);

  const serverUrl =
    window.location.hostname === "localhost" ||
    window.location.hostname === "192.168.0.254"
      ? `http://${window.location.hostname}:4000`
      : `${window.location.protocol}//smes.izenimplant.com`;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (id === "" || password === "" || gu === "") {
      setError("사용자명, 비밀번호를 입력하세요.");
      return;
    }

    setError("");

    try {
      const res = await fetch(`${serverUrl}/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, password, gu }),
      });

      const data = await res.json();

      console.log("로그인 응답:", data);

      // 🔴 실패 시
      if (!data.success) {
        setError(data.error || "로그인 실패");
        return;
      }

      // 🔵 성공 시만 로그인 처리
      if (rememberMe) {
        Cookies.set("id", id, { expires: 3650 });
        Cookies.set("gu", gu, { expires: 3650 });
      } else {
        Cookies.remove("id");
        Cookies.remove("gu");
      }

      onLoginSuccess(
        data.BCE_CODE,
        data.BCE_NAME,
        data.GU,
        data.BCU_CODE,
        data.BCU_NAME,
        data.SYSTEMYN
      );

    } catch (err) {
      console.error("로그인 에러:", err);
      setError(err.message || "로그인 실패");
    }
  };

  return (
    <div className="login-container">
      <h1>IZEN IMPLANT</h1>
      <h2>로그인</h2>

      <div className="user-type-container">
        <label>
          <input
            type="radio"
            name="gu"
            value="1"
            checked={gu === "1"}
            onChange={(e) => setGu(e.target.value)}
          />
          개인
        </label>
        <label>
          <input
            type="radio"
            name="gu"
            value="2"
            checked={gu === "2"}
            onChange={(e) => setGu(e.target.value)}
          />
          기업
        </label>
      </div>

      <form onSubmit={handleSubmit} className="login-form">
        <div className="input-container">
          <label>사용자명</label>
          <input
            type="text"
            value={id}
            onChange={(e) => setId(e.target.value)}
            placeholder="사용자명을 입력하세요"
          />
        </div>

        <div className="input-container">
          <label>비밀번호</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="비밀번호를 입력하세요"
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="input-container remember-me-container">
          <label>
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            아이디 저장
          </label>
        </div>

        <button type="submit" className="login-button">
          로그인
        </button>
      </form>
    </div>
  );
};

export default Login;
